import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem, Container} from "mdbreact";
import {Link} from "react-router-dom";

export default class HotelRules extends Component {
    render() {
        return (
            <div className="pt-3">
                <Container>
                    <Breadcrumb className='w-100 white mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem active>قوانین استفاده از هتلها</BreadcrumbItem>
                    </Breadcrumb>

                    <div className="white p-3 rtl">

                    <div className="row">
                        <div className="col-sm-12" style={{minHeight:500}}>
                            <h3>قوانین استفاده از هتلها</h3>
                            <p className="text-justify">لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.</p>
                        </div>

                    </div>
                </div>
                </Container>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/pages/HotelRules.js